import { SudoConsts } from 'client/util/Constants';

/**
 * Text for System User features to avoid magic strings across multiple components
 */
export const dateDisplayFormat = 'MMM D, YYYY @ h:mm A';

export const systemUserMessageText = {
  forcePasswordInfoText: 'You haven\'t turned this setting on for your org. Forcing this change turns the setting on and all expired users are able to change their passwords. You can change this setting on the Settings page.',
};

/**
 * Helpers for user state manipulation
 */
export const userStateActionType = {
  activate: 'activate',
  suspend: 'suspend',
};

// Helper function to make a simple object that actions map to, for clarity
const mapValue = (noun, verb, adjective, result) => ({
  noun,
  verb,
  adjective,
  result,
});

/**
 * Map to help convert user states to corresponding actions.
 */
export const userStateActionMap = new Map([
  [userStateActionType.activate, mapValue('activation', 'activating', 'activated', 'restore')],
  [userStateActionType.suspend, mapValue('suspension', 'suspending', 'suspended', 'remove')],
]);

export const SystemUserLabels = {
  accountLocked: 'account locked out',
  externallyManaged: 'AD managed',
  globalAdmin: SudoConsts.globalSudo.toLowerCase(),
  globalAdminSudo: SudoConsts.globalSudo.toLowerCase(),
  globalAdminPasswordless: SudoConsts.globalPasswordless.toLowerCase(),
  ldap: 'LDAP bind DNs',
  noPassword: 'no password',
  noPasswordOnFile: 'no password on file',
  passwordExpired: 'password expired',
  passwordExpiring: (days) => `password expiring within ${days} days`,
  passwordPending: 'password pending',
  pending: 'pending',
  sambaAccess: 'samba access',
  userSuspended: 'account suspended',
};
export default {
  dateDisplayFormat,
  systemUserMessageText,
  SystemUserLabels,
  userStateActionMap,
  userStateActionType,
};
